import React from 'react';
import styled from 'styled-components';
import { Input as AntInput } from 'antd';
import defaultTheme from '../../../theme/theme';
import { getThemeComponentColor } from '../../../hooks/useGetThemeComponentColor';
import Typography from '../../shared/typography/Typography';
import colors, { TypeColorNames } from '../../../theme/colors';

interface StyledInputProps {
  style?: any;
  color: TypeColorNames;
  borderRadius?: number;
  backgroundColor: TypeColorNames;
  inputColor: TypeColorNames;
}

export interface IInput {
  style?: any;
  color: TypeColorNames;
  error?: string;
  onChange?: any;
  onPressEnter?: any;
  borderRadius?: number;
  leftIcon?: any;
  placeholderText?: string;
  backgroundColor: TypeColorNames;
  inputColor: TypeColorNames;
  value?: any;
  searchString?: string;
}

const DEFAULT_COLOR = 'placeholder';

const getBorderRadius = ({ borderRadius }: StyledInputProps): number => {
  if (!borderRadius) return 8;

  return borderRadius;
};

const StyledInput = styled.div<StyledInputProps>`

  .ant-input-affix-wrapper, >input{
    color: ${defaultTheme.colors.title};
    border-radius: ${getBorderRadius}px;
    border-color: ${props => props.color};
    padding: 11px;
    background-color: ${(props) => props.backgroundColor};
  }

  input {
    color: ${(props) =>  props.inputColor};
    background-color: ${(props) => props.backgroundColor};

      ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: ${(props) => props.theme.colors.placeholder};
        opacity: 1; /* Firefox */
      }
      
      :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: ${(props) => props.theme.colors.placeholder};
      }
      
      ::-ms-input-placeholder { /* Microsoft Edge */
        color: ${(props) => props.theme.colors.placeholder};
      }
  }


  .ant-input-affix-wrapper:hover, input:hover{
    border-color: ${(props) => props.color}
  }


  .ant-input-affix-wrapper:focus, .ant-input-affix-wrapper-focused, .ant-input:focus, .ant-input-focused{
    border-color: ${(props) => props.color};
    box-shadow: 0 0 ;
  }

`;

const CustomInput = ({
  style,
  color,
  error,
  borderRadius,
  leftIcon,
  onChange,
  onPressEnter,
  placeholderText,
  backgroundColor,
  value,
  inputColor,
  searchString,
  ...rest
}: IInput) => (
  <StyledInput
    inputColor={inputColor}
    borderRadius={borderRadius}
    backgroundColor={backgroundColor}
    color={color}
    style={{ ...style }}
    {...rest}
  >
    <AntInput
      placeholder={placeholderText}
      prefix={leftIcon}
      onChange={onChange}
      onPressEnter={onPressEnter}
    /> 

    <Typography type="body4" color="error">
      {error}
    </Typography>
  </StyledInput>
);

CustomInput.defaultProps = {
  color: DEFAULT_COLOR,
  backgroundColor: 'white',
  inputColor: 'title',
};

export default CustomInput;